import customFields from "./custom-fields";
import customFieldSchema from "./custom-field-schema";

import { combineReducers } from "redux";

export default combineReducers({
  customFieldSchema,
  customFields,
});
